// extracted by mini-css-extract-plugin
export default {"Paper":"Paper_Paper__ZgAxH","LightPaper":"Paper_LightPaper__4wcTP","DarkPaper":"Paper_DarkPaper__GjuGa"};